export const descriptionOfSteps = {
	/* Some icons could be added : 'uniqueCode', 'login', 'gift'… */


	registration: {
		icon: ['registration', 'flat_registration'][0],
		translation: 'registration',
		activeOnPages: ['registration']
	},
	store: {
		icon: ['store', 'flat_store'][0],
		translation: 'store',
		activeOnPages: ['landing']
	},
	info: {
		icon: ['info', 'flat_info'][0], 
		translation: 'info',
		activeOnPages: ['instructions'],
	},
	form: {
		icon: ['form', 'flat_form'][0],
		translation: 'form',
		activeOnPages: ['form1', 'form2']
	},
	survey: {
		icon: ['survey', 'flat_question'][0],
		translation: 'survey',
		activeOnPages: ['choiceSurvey', 'survey']
	},
	summary: {
		icon: ['summary', 'flat_form'][0],
		translation: 'summary',
		activeOnPages: ['summary']
	},
	confirmation: {
		icon: ['cashback', 'gift', 'flat_confirm', 'flat_gift', 'flat_cashback', 'ticket', 'flat_ticket'][0],
		translation: ['cashback', 'coupon'][0],
		activeOnPages: ['confirmation']
	},
};